<template>
	<div>
		<div class="select-box">
			<span>客户名称：</span>
			<el-input
				v-model="userName"
				placeholder="请输入客户名称"
				class="name-input"
				size="mini"
				@keyup.enter.native="selectCLick"
				>
				<el-button @click='selectCLick' slot="append" size='mini' icon="el-icon-search"></el-button>
			</el-input>
		</div>
		<div style="width: 100%; height: 400px;margin-top: 10px; display: flex;flex-direction: row;justify-content: space-between;">
			<div class="left-box">
				<div class="btn-box">
					<div class="check-all">
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
					</div>
					<div class="btn-group">
						<div @click="typeChange(0)" class="btn left" :class="type === 0 ? 'active' :''">选择类别</div>
						<div @click="typeChange(1)" class="btn right" :class="type === 1 ? 'active' :''">选择客户</div>
					</div>
				</div>
				<div class="tree-box">
					<div v-for="(item,index) in treeData" :key='index'>
						<div class="title-box" @click="showCusChange(index)">
							<div class="left">
								<el-checkbox :true-label='1' :false-label='0' v-if="type === 0" v-model="item.checked" @change='cateChange(item,item.checked)'></el-checkbox>
								<img style="margin:0px 5px;" src="~/images/icon/customerCategory.png">
								<span style="color: #333333;">{{item.name}}</span>
							</div>
							<div class="right">
								<i v-if="item.showCus === 1" class="el-icon-arrow-up"></i>
								<i v-if="item.showCus === 0" class="el-icon-arrow-down"></i>
							</div>
						</div>
						<div class="content-box" v-show='item.showCus ===1' v-for='(item1,index1) in item.cus' :key='index1'>
							<el-checkbox :true-label='1' :false-label='0' v-if="type === 1" v-model="item1.checked" @change='customerChange(item,item1,item1.checked)'>
								<span style="color: #595959;">{{item1.name}}</span>
							</el-checkbox>
							<span v-else style="color: #595959;">{{item1.name}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="right-box">
				<div v-if="chooseData.length>0">
					<div>
						<div @click="meTitleClick" class="staff-name-box">
							我的
							<i v-if="show" class="el-icon-arrow-up"></i>
							<i v-else class="el-icon-arrow-down"></i>
						</div>
						<div v-show="show" v-for="(item,index) in chooseData" :key='index'>
							<div class="title-box" @click="chooseShowCusChange(item.categoryFlag,index)">
								<div class="left" style="color: #333333;">
									<img style="margin:0px 5px;" src="~/images/icon/customerCategory.png">
									<span>{{item.name}}</span>
									<img v-if="item.categoryFlag === 1" style="margin:0px 5px;" src="~/images/icon/allCategory.png">
									<span v-if="item.categoryFlag === 1">整类</span>
								</div>
								<div class="right">
									<i @click="delCateClick(item,index)" v-if="item.categoryFlag === 1" class="el-icon-close"></i>
									<i v-if="item.categoryFlag !== 1 && item.showCus ===1" class="el-icon-arrow-up"></i>
									<i v-if="item.categoryFlag !== 1 && item.showCus ===0" class="el-icon-arrow-down"></i>
								</div>
							</div>
							<div style="color: #595959;" class="content-box" v-show="item.categoryFlag === 0 && item.showCus ===1" v-for="(item1,index1) in item.cus" :key='index1'>
								{{item1.name}}
								<i @click="delCusClick(item,item1,index,index1)" class="el-icon-close"></i>
							</div>
						</div>
					</div>
				</div>
				<div v-for="(staff,index) in staffList" :key='index'>
					<div>
						<div class="staff-name-box" @click="staffShowClick(index)">
							{{staff.userName}}
							<i v-if="staff.show" class="el-icon-arrow-up"></i>
							<i v-else class="el-icon-arrow-down"></i>
						</div>
						<div v-show="staff.show" v-for="(item,index1) in staff.category" :key='index1'>
							<div class="title-box" @click="staffShowCusChange(staff.categoryFlag,index,index1)">
								<div class="left" style="color: #333333;" >
									<img style="margin:0px 5px;" src="~/images/icon/customerCategory.png">
									<span>{{item.name}}</span>
									<img v-if="item.categoryFlag === 1" style="margin:0px 5px;" src="~/images/icon/allCategory.png">
									<span v-if="item.categoryFlag === 1">整类</span>
								</div>
								<div class="right">
									<i v-if="item.categoryFlag !== 1 && item.showCus ===1" class="el-icon-arrow-up"></i>
									<i v-if="item.categoryFlag !== 1 && item.showCus ===0" class="el-icon-arrow-down"></i>
								</div>
							</div>
							<div style="color: #595959;" class="content-box" v-show="item.categoryFlag === 0 && item.showCus ===1" v-for="(item1,index1) in item.cus" :key='index1'>
								{{item1.name}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="display: flex;flex-direction: row;margin-top: 10px;align-items: center;">
			<img style="width: 14px;height: 14px;margin-right: 5px;" src="~/images/icon/tip.png">
			<div style="color: #999999;text-align: left;">
				当前页仅可对自己直接管理的客户进行编辑，如需对下属员工客户
			</div>
		</div>

		<div style="color: #999999;margin: 0px 0px 10px 19px;text-align: left;">
			进行编辑，请在列表页找到该员工，进行编辑。
		</div>
		<div v-if="isEdit" style="width: 100%;height: 30px;margin-bottom: 10px;display: flex;align-items: center;justify-content: flex-end;">
			<el-button @click='closeClick' size='mini'>取消</el-button>
			<el-button @click='saveClick' size='mini' type="primary">确定</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'bindCustomer',
	props: {
		staffId: String,
		isEdit: Boolean,
		customerDialog: Boolean,
		openType: Number
	},
	data () {
		return {
			show: true,
			userName: '',
			type: 0,
			chooseData: [],
			treeData: [],
			staffList: [],
			checkAll: false,
			isIndeterminate: false
		}
	},
	created () {
		this.getTree()
	},
	watch: {
		treeData: {
			handler (val) {
				this.checkAll = val.every(item => {
					return item.checked === 1
				})
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		handleCheckAllChange (val) {
			let num = val ? 1 : 0
			this.chooseData = val ? JSON.parse(JSON.stringify(this.treeData)) : []
			this.isIndeterminate = false
			this.checkedAllChooseData(this.treeData, num)
		},
		checkedAllChooseData (array, num) {
			array.forEach(item => {
				item.checked = num
				item.cus.forEach(cusItem => {
					cusItem.checked = num
				})
			})
			this.chooseData.forEach(item => {
				item.categoryFlag = num
			})
		},
		closeClick () {
			this.$emit('update:customerDialog', false)
		},
		meTitleClick () {
			this.show = !this.show
		},
		staffShowClick (index) {
			console.log(index)
			this.staffList[index].show = !this.staffList[index].show
		},
		sort (data) {
			let allCus = []
			let cus = []
			for (let i = 0; i < data.length; i++) {
				if (data[i].categoryFlag === 1) {
					allCus.push(data[i])
				} else {
					cus.push(data[i])
				}
			}
			return allCus.concat(cus)
		},
		delCusClick (cate, cus, index, cusIndex) {
			this.chooseData[index].cus.splice(cusIndex, 1)
			if (this.chooseData[index].cus.length === 0) {
				this.chooseData.splice(index, 1)
			}
			let list = this.treeData
			for (let i = 0; i < list.length; i++) {
				if (list[i].id === cate.id) {
					list[i].checked = 0
					for (let j = 0; j < list[i].cus.length; j++) {
						if (list[i].cus[j].id === cus.id) {
							list[i].cus[j].checked = false
						}
					}
				}
			}
			this.chooseData = this.sort(this.chooseData)
		},
		delCateClick (cate, index) {
			this.chooseData.splice(index, 1)
			let list = this.treeData
			for (let i = 0; i < list.length; i++) {
				if (list[i].id === cate.id) {
					list[i].checked = 0
					for (let j = 0; j < list[i].cus.length; j++) {
						list[i].cus[j].checked = 0
					}
				}
			}
			this.chooseData = this.sort(this.chooseData)
		},
		selectCLick () {
			let params = {
				name: this.userName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/customer/getCustomerCategoryAndCustomerInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.treeData = res.data
					this.initTreeData()
				}
			})
		},
		initTreeData () {
			let chooseList = JSON.parse(JSON.stringify(this.chooseData))
			let treeList = JSON.parse(JSON.stringify(this.treeData))
			for (let i = 0; i < chooseList.length; i++) {
				for (let j = 0; j < treeList.length; j++) {
					if (chooseList[i].id === treeList[j].id) {
						if (chooseList[i].categoryFlag === 1) {
							treeList[j].checked = 1
							for (let z = 0; z < treeList[j].cus.length; z++) {
								treeList[j].cus[z].checked = 1
							}
						} else {
							treeList[j].checked = 0
							for (let x = 0; x < chooseList[i].cus.length; x++) {
								for (let c = 0; c < treeList[j].cus.length; c++) {
									if (chooseList[i].cus[x].id === treeList[j].cus[c].id) {
										treeList[j].cus[c].checked = 1
									}
								}
							}
						}
					}
				}
			}
			this.treeData = treeList
		},
		showCusChange (index) {
			if (this.treeData[index].showCus === 1) {
				this.treeData[index].showCus = 0
			} else {
				this.treeData[index].showCus = 1
			}
		},
		staffShowCusChange (flag, index, index1) {
			if (flag === 1) {
				return false
			}
			if (this.staffList[index].category[index1].showCus === 1) {
				this.staffList[index].category[index1].showCus = 0
			} else {
				this.staffList[index].category[index1].showCus = 1
			}
		},
		chooseShowCusChange (flag, index) {
			if (flag === 1) {
				return false
			}
			if (this.chooseData[index].showCus === 1) {
				this.chooseData[index].showCus = 0
			} else {
				this.chooseData[index].showCus = 1
			}
		},
		initStaffList (data) {
			let list = JSON.parse(JSON.stringify(data))
			let chooseList = []
			let staffList = []
			for (let i = 0; i < list.length; i++) {
				if (list[i].meFlag === 1) {
					chooseList = list[i].category
				} else {
					staffList.push(list[i])
				}
			}
			this.chooseData = this.openType === 1 ? chooseList : []
			this.chooseData = this.sort(this.chooseData)
			for (let i = 0; i < staffList.length; i++) {
				staffList[i].show = true
				staffList[i].category = this.sort(staffList[i].category)
			}
			this.staffList = staffList
			this.initTreeData()
		},
		cateChange (cate, isChoose) {
			let i = null
			let chooseIndex = null
			this.treeData.forEach((item, index) => {
				if (item.id === cate.id) {
					i = index
				}
			})
			this.chooseData.forEach((item, index) => {
				if (item.id === cate.id) {
					chooseIndex = index
				}
			})
			this.treeData[i].cus.forEach(item => {
				item.checked = isChoose
			})
			if (isChoose === 1) {
				let cus = JSON.parse(JSON.stringify(this.treeData[i].cus))
				let row = {
					'name': cate.name,
					'id': cate.id,
					'showCus': 1,
					'categoryFlag': 1,
					'cus': cus
				}
				if (chooseIndex === null) {
					this.chooseData.push(row)
				} else {
					this.chooseData.splice(chooseIndex, 1)
					this.chooseData.push(row)
				}
			} else {
				this.chooseData.splice(chooseIndex, 1)
			}
			this.chooseData = this.sort(this.chooseData)
		},
		initShopData (type) {
			let textArr = []
			let idArr = []
			let list = this.chooseData
			list.forEach(item => {
				item.cus.forEach(shop => {
					if (shop.id !== '-1') {
						textArr.push(shop.name)
						idArr.push(shop.id)
					}
				})
			})
			if (type === 'name') {
				let text = textArr.join('，')
				return text
			}
			if (type === 'id') {
				return idArr
			}
		},
		saveClick () {
			if (this.chooseData.length === 0) {
				this.$message.error('至少选择一个客户')
				return false
			}
			let params = {
				chooseData: this.chooseData,
				cusText: this.initShopData('name'),
				allData: this.staffList.length > 0 ? [...this.chooseData, ...this.staffList[0].category] : this.chooseData
			}
			console.log(params)
			this.$emit('reloadCustomer', params)
			this.$emit('closepage')
			// let params = {
			// 	userId: this.staffId,
			// 	category: this.chooseData
			// }
			// this.$store.dispatch('requestPost', {
			// 	url: `${this.$fxBaseApi.urlIV}/account/businessStaff/saveUserManageredCustomer`,
			// 	data: params
			// }).then(res => {
			// 	if (res.result) {
			// 		this.$emit('closepage')
			// 		this.$message.success('保存成功！')
			// 	}
			// })
		},
		getChoose () {
			let params = {
				staffId: this.staffId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/businessStaff/findUserManageredCustomerInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.initStaffList(res.data)
				}
			})
		},
		getTree (val) {
			let params = {
				name: this.userName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/customer/getCustomerCategoryAndCustomerInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.treeData = res.data
					this.getChoose()
				}
			})
		},
		typeChange (data) {
			this.type = data
		},
		customerChange (cate, cusrow, isChoose) {
			this.treeData.forEach(item => {
				if (item.id === cate.id) {
					item.checked = 0
				}
			})
			let list = JSON.parse(JSON.stringify(this.chooseData))
			let flag = false
			let cateIndex = null
			for (let i = 0; i < list.length; i++) {
				if (list[i].id === cate.id) {
					flag = true
					cateIndex = i
				}
			}
			if (isChoose === 1) {
				if (flag) {
					list[cateIndex].categoryFlag = 0
					list[cateIndex].cus.push(cusrow)
				} else {
					let row = {
						'name': cate.name,
						'id': cate.id,
						'categoryFlag': 0,
						'showCus': 1,
						'cus': [cusrow]
					}
					list.push(row)
				}
			} else {
				list[cateIndex].categoryFlag = 0
				let cusList = list[cateIndex].cus
				let cusIndex = null
				cusList.forEach((item, index) => {
					if (cusrow.id === item.id) {
						cusIndex = index
					}
				})
				list[cateIndex].cus.splice(cusIndex, 1)
				if (list[cateIndex].cus.length === 0) {
					list.splice(cateIndex, 1)
				}
			}
			this.chooseData = this.sort(list)
		}
	}
}
</script>

<style lang="stylus" scoped>
.staff-name-box{
	display:flex;
	align-items center;
	justify-content:center
	color :#999999;
	height :40px;
	cursor :pointer;
	position :relative
}
.staff-name-box::before{
	content:'';
	width:60px;
	border-bottom:1px solid #E3E3E3;
	position:absolute;
	left:20px;
	top:20px;
}
.staff-name-box::after{
	content:'';
	width:60px;
	border-bottom:1px solid #E3E3E3;
	position:absolute;
	right:20px;
	top:20px;
}
.el-icon-arrow-up{
	color:#AFB1B3 !important
}
.el-icon-arrow-down{
	color:#AFB1B3 !important
}
.select-box{
	display flex
	width: 100%;
	align-items: center;
	height: 40px;
	span {
		margin-right: 10px
	}
	.name-input {
		flex: 1;
	}
}
.left-box{
	width: 350px;
	height: 100%;
	display :flex;
	flex-direction :column;
	background-color: #F9F9F9
	.btn-box{
		position: relative;
		width :100%;
		height:40px;
		display :flex;
		margin-top :5px;
		align-items :center;
		justify-content :center;
		.check-all {
			position: absolute;
			left: 5px
		}
		.btn-group{
			width:160px;
			height :32px;
			display :flex;
			flex-direction :row;
			.btn{
				font-weight :400;
				cursor :pointer;
				background-color :white;
				font-size 12px;
				display:flex;
				align-items :center;
				justify-content:center;
				flex:1;
				border :1px solid #E0E0E0;
				color :#333333
			}
			.right{
				border-radius: 0px 4px 4px 0px;
			}
			.left{
				border-radius: 4px 0px 0px 4px;
			}
			.active{
				font-weight :bold;
				color :var(--fx-primary-color) !important;
				border :1px solid var(--fx-primary-color) !important;
			}
		}
	}
	.tree-box{
		flex:1;
		padding: 5px;
		overflow-y: auto;
	}
}
.title-box{
	display:flex;
	flex-direction :row;
	justify-content:space-between;
	align-items :center;
	.left{
		display:flex;
		flex-direction :row;
		align-items :center;
		height :30px;
	}
}
.content-box{
	display:flex;
	flex-direction :row;
	align-items :center;
	height :30px;
	padding-left:30px;
	box-sizing :border-box;
}
.right-box{
	box-sizing:border-box;
	padding :10px;
	width: 350px;
	height: 100%;
	overflow-y:auto;
	background-color: #F9F9F9
	.content-box{
		justify-content :space-between
	}
}
</style>
